import { Typography } from "@mui/material";
import { useMemo } from "react";

export const MaxItems = ({
  count: { selectedLength, minLength, maxLength, template },
}) => {
  const text = useMemo(() => {
    if (!selectedLength && !minLength) return;

    if (!selectedLength && minLength)
      return `Adicione ao menos ${minLength} item`;

    if (selectedLength === maxLength)
      return `Total de ${maxLength} itens atingido`;

    const defaultValue = (template || "$count de $max selecionado(s)")
      .replace("$count", selectedLength)
      .replace("$max", maxLength);
    return defaultValue;
  }, [maxLength, minLength, selectedLength, template]);

  return (
    <>
      {text && (
        <Typography
          sx={{ marginLeft: "auto", fontSize: 12, fontWeight: "410" }}
        >
          {text}
        </Typography>
      )}
    </>
  );
};
